import React, { useState, useEffect } from 'react';
import Header from './header';
import Homepage_Banner from '../assets/homepage_banner.png';
import Banner_IMG_TEXT from '../assets/header_banner_text.png';
import Search from './search';

import './homepageHeader.scss';

interface IProps {
  backgroundPicUrl?: string;
  topicPicUrl?: string;
  id?: string;
}

const HomepageHeader = (props: IProps) => {
  const [mask, setMask] = useState(false);

  const search = () => setMask(true);
  const hide = () => setMask(false);

  return (
    <div className='homepage-header-content '>
      <Header className='homepage-header'></Header>
      <img className='banner-img-bg ' src='/api/home_page/pic_load/activity/background' width='100%' alt='' />
      <div className='search-banner-content '>
        <img src='/api/home_page/pic_load/activity/topic' alt='' className='banner-img-text' />
        <Search onSearch={search} />
      </div>
      {/* <div className={`mask ${!mask ? 'hide' : ''}`} onClick={hide}></div> */}
    </div>
  );
};

export default HomepageHeader;
